import React, { Component } from 'react'
import { addLocaleData, IntlProvider } from 'react-intl'
import ConfigProvider from 'antd/lib/config-provider'
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import enUS from 'antd/lib/locale-provider/en_US';
import frFR from 'antd/lib/locale-provider/fr_FR';

import localeData from 'src/language/output/translation.json';

addLocaleData([...en, ...fr]);

class LanguageWrapper extends Component {
  componentDidMount() {
    this.props.setLanguage(this.props.language, false, 'onRender')
  }

  getMessages = (language) => {
    if (!language) {
      language = 'en' //eslint-disable-line
    }
    // Split locales with a region code
    const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

    return localeData[language] || localeData[languageWithoutRegionCode] || localeData.en;
  }

  getAntLanguage = (language) => {
    return language === 'en' ? enUS : frFR
  }

  render() {
    const { children, language } = this.props

    return (
      <ConfigProvider locale={this.getAntLanguage(language)}>
        <IntlProvider locale={language} messages={this.getMessages(language)}>
          { children }
        </IntlProvider>
      </ConfigProvider>
    )
  }
}

export default LanguageWrapper
